import React from 'react';

interface CompleteStepProps {
  trustRegistry: any;
  onFinish: () => void;
  onViewTrustRegistry: () => void;
}

const CompleteStep: React.FC<CompleteStepProps> = ({ trustRegistry, onFinish, onViewTrustRegistry }) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="text-center py-5">
          <div className="mb-4">
            <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
          </div>
          
          <h3 className="mb-3">Trust Registry Added Successfully!</h3>
          
          <p className="text-muted mb-4">
            The trust registry has been successfully added to your system.
          </p>

          <div className="card bg-light mb-4 mx-auto" style={{ maxWidth: '600px' }}>
            <div className="card-body text-left">
              <h5 className="font-weight-bold mb-3 text-center">{trustRegistry.name}</h5>
              
              <div className="mb-3">
                <strong>DID:</strong>
                <div className="mt-1">
                  <code style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{trustRegistry.did}</code>
                </div>
              </div>

              {trustRegistry.description && (
                <div className="mb-3">
                  <strong>Description:</strong>
                  <div className="mt-1">{trustRegistry.description}</div>
                </div>
              )}

              <div className="mb-3">
                <strong>Status:</strong>
                <div className="mt-1">
                  <span className="badge badge-success">ACTIVE</span>
                </div>
              </div>

              <div className="mb-0">
                <strong>Created:</strong>
                <div className="mt-1">
                  {new Date(trustRegistry.created_at).toLocaleString()}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center" style={{ gap: '1rem' }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onFinish}
            >
              <i className="fas fa-list mr-2"></i> View All Trust Registries
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onViewTrustRegistry}
            >
              <i className="fas fa-edit mr-2"></i> Edit Trust Registry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteStep;
